import { render } from "./ZNBJedit.vue?vue&type=template&id=20f6ee9c&scoped=true"
import script from "./ZNBJedit.vue?vue&type=script&lang=js"
export * from "./ZNBJedit.vue?vue&type=script&lang=js"

import "./ZNBJedit.vue?vue&type=style&index=0&id=20f6ee9c&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f6ee9c"]])

export default __exports__